import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import * as moment from 'moment';

@Pipe( { name: 'nodaydiff' })

export class getdatediff implements PipeTransform
{
    //**************************************************************
    transform( val, enddate, nodays)
        {
           
                var schstartdate    = formatDate( val, 'yyyy-MM-ddT00:00:00', 'en' );
                var schenddate      = formatDate( enddate, 'yyyy-MM-ddT00:00:00', 'en' );  
    
                var a = moment( schstartdate );
                var b = moment( schenddate ); 
                var nodaydiff = b.diff(a, 'days') + nodays

                if ( nodaydiff <= 0 ) 
                    {
                        nodaydiff = 0  
                    }
                            
                return nodaydiff;               
        }    
    //**************************************************************             
}